import { Typography, Stack, Paper, Avatar, Box, Chip } from '@mui/material';
import { Link } from 'react-router-dom';
import { Add } from '@mui/icons-material';

const InvitePlayersComponent = ({
  gameData,
  usersWithPhotoURL,
  userHasAcceptedADate,
  subPath,
  hasDate,
  isOrganiser,
}) => {
  const showInviteButton =
    ((isOrganiser && gameData.visibility === 'Private') || gameData.visibility === 'Public') &&
    !hasDate;
  
  const userHasDeclined = (user) => {
    return (gameData.declinedBy || []).indexOf(user.userId || user.id || user.uid) !== -1;
  };

  // Check if this is a single-date game (confirmed status or only one date option)
  const isSingleDateGame = () => {
    return gameData.status === 'confirmed' || 
           (gameData.dateTimeOptions && gameData.dateTimeOptions.length <= 1);
  };

  // For single-date games, also check if user is in the players array
  const userIsAvailable = (user) => {
    const userId = user.userId || user.id || user.uid;
    
    if (isSingleDateGame()) {
      // For single-date games, check if user is in players array
      return gameData?.players?.some(player => player.user === userId) || userHasAcceptedADate(user);
    }
    
    // For multi-date games, use the existing logic
    return userHasAcceptedADate(user);
  };

  return (
    <Paper elevation={0} variant="gameBox">
      <Typography variant="moduleHeader" component="h5">
        Players
      </Typography>
      <Stack direction="column" spacing={2}>
        {(usersWithPhotoURL || []).map((user, index) => (
          <Stack direction="row" sx={{ ml: 2 }} key={index}>
            {user.photoURL ? (
              <Avatar
                alt={user.userName || user.userId}
                sx={{
                  bgcolor: index % 2 === 0 ? '#E9FFEA' : '#F9EDFF',
                  width: '48px',
                  height: '50px',
                }}
                src={user.photoURL}
              />
            ) : (
              <Box
                sx={{
                  bgcolor: index % 2 === 0 ? '#E9FFEA' : '#F9EDFF',
                  width: '48px',
                  height: '50px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '50%',
                }}
              >
                <Typography
                  variant="factorA"
                  color="primary"
                  component="small"
                  sx={{ color: '#4C4C4C' }}
                >
                  {user?.initial}
                </Typography>
              </Box>
            )}
            {user.type === 'player' ? (
              <Stack sx={{ ml: 2 }}>
                <Typography variant="body1">
                  <b>{user.userName}</b>
                </Typography>
                {gameData.splitCosts && user.paid && (
                  <Typography variant="body1">
                    Paid &pound;{Number(gameData.cost || 0) / gameData.invitations.length}
                  </Typography>
                )}
                {gameData.splitCosts && !user.paid && (
                  <Typography variant="body1" sx={{ color: 'red' }}>
                    Owes &pound;{Number(gameData.cost || 0) / gameData?.players?.length}
                  </Typography>
                )}
              </Stack>
            ) : (
              <Box sx={{ ml: 2 }}>
                <Typography variant="body1">
                  <b>{user.userName}</b>
                </Typography>
                {userIsAvailable(user) && (
                  <Chip className="chip_status" variant="statusAvailable" label="Available" />
                )}
                {userHasDeclined(user) ? (
                  <Chip className="chip_status" variant="statusDeclined" label="Declined" />
                ) : (
                  <>
                    {!userIsAvailable(user) && (
                      <Chip className="chip_status" variant="statusInvited" label="Not Available" />
                    )}
                  </>
                )}
              </Box>
            )}
          </Stack>
        ))}
        {showInviteButton && (
          <Avatar
            component={Link}
            to={subPath}
            sx={{ width: 48, height: 48, bgcolor: '#eeeeee', cursor: 'pointer' }}
          >
            <Add />
          </Avatar>
        )}
      </Stack>
    </Paper>
  );
};

export default InvitePlayersComponent;
